
import Layout from './Layout.vue'
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  onUnmounted,
  provide,
  reactive,
  Ref,
  ref,
  watch
} from 'vue'
import { connectWallet, getChainId, getProvider } from '@/composables/metamask'
import { useRoute, useRouter } from 'vue-router'
import {
  HappyRedPacketContract,
  RedPacketContract
} from '@/contract/func/redPacket'
import redPacketAddress from '@/contract/redPacketAddress'
import { ethers, providers } from 'ethers'
import redPackABI from '@/contract/abi/HappyRedPacket.json'
import BigNumber from 'bignumber.js'
import { Http } from '@/plugins/axios'
import ChainTag from '@/components/ChainTag.vue'
import ShareButton from '@/components/common/ShareButton.vue'
import TxLoading from '@/components/txLoading.vue'
import PersonalityButton from '@/components/common/PersonalityButton.vue'
import { IChainId } from '@/interface'
import ReviceRedPack from '@/components/ReviceRedPack.vue'
import BgSlot from '@/components/BgSlot.vue'
import Loading from '@/components/common/loading.vue'
import { getNonceAPIHandler } from '@/composables/aes'
import ExpirePs from '@/components/ExpirePs.vue'
import RedpackInfo from '@/components/RedpackInfo.vue'
import { useStore } from 'vuex'
import type { State as WalletState } from '@/store/wallet'
import { HappyRedPacket } from '@/contract/helper/abi/HappyRedPacket'
import { useRecaptcha } from '@/composables/recaptcha'

export default defineComponent({
  components: {
    Layout,
    ShareButton,
    TxLoading,
    PersonalityButton,
    Loading,
    ExpirePs,
    BgSlot,
    RedpackInfo
  },

  setup () {
    const recaptchaCode = process.env.VUE_APP_RECAPTCHA as string

    const openLoading = ref(false)

    let provider: ethers.providers.Web3Provider

    const recaptchaShow = ref(false)

    const chainIdInit = ref() as Ref<IChainId>
    const redPackContractAddr = ref('')

    const isFxWallet = inject('isFxWallet')
    // const isFxWallet = true

    const isType = ref('ownOpen') // ownOpen download open sorry

    const isViewRecords = ref(false)

    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const recaptcha = useRecaptcha()

    const query = route.query as {
      chainId: string;
      redPackId: string;
      chainIdInit: string;
      skin: string;
      nonce: string;
    }

    const redPackId = query.redPackId

    const loading = ref(false)

    const address = computed(() => {
      return store.state.wallet.account as WalletState['account']
    })

    const wallet = computed(() => {
      return store.state.wallet.wallet as WalletState['wallet']
    })

    const walletReady = computed(() => {
      return store.state.wallet.ready as WalletState['ready']
    })

    const nonceInit = ref('')

    const redPackReady = ref(false)

    const redPackContract = computed(() => {
      return store.state.contractRedpack.contract as HappyRedPacketContract
    })

    const redPackInfo = reactive({
      tokenAddress: '',
      balance: '',
      total: '',
      claimed: '',
      expired: false,
      claimedAmount: ''
    })

    const redPackBasicInfo = computed(() => {
      return store.state.info.basic
    })

    const infoReady = computed(() => {
      return store.state.info.ready
    })

    const showViewRecords = () => {
      isViewRecords.value = true
    }

    /**
     * 是否发起者打开红包
     */
    const isRedPackOwn = computed(() => {
      return address.value.show === redPackBasicInfo.value.sender
    })

    /**
     * 是否已领取红包
     * claimedAmount > 0
     */
    const isRedPackReceive = computed(() =>
      new BigNumber(redPackInfo.claimedAmount).gt(0)
    )

    /**
     * 是否已全部领取
     * claimed >= total
     */
    const isRedPackFinished = computed(() =>
      checkRedPackFinished(redPackInfo.claimed, redPackInfo.total)
    )

    /**
     * 红包是否处于可领取状态
     * isRedPackFinished: false
     * isRedPackReceive: false
     * redPackInfo.expired: false
     */
    const isRedPackAailable = computed(() => {
      // 已领取数量是否少于红包数量
      // 是否已过期
      return (
        !isRedPackFinished.value &&
        !redPackInfo.expired &&
        !isRedPackReceive.value
      )
    })

    /**
     * 检查是否已全部领取
     */
    function checkRedPackFinished (claimed: string, total: string) {
      return new BigNumber(claimed).gte(total)
    }

    /**
     * 从合约获取红包基本信息
     */
    async function checkRedPackAvailability (redPackId: string) {
      return redPackContract.value.contract.check_availability(redPackId, {
        from: address.value.normal
      })
    }

    /**
     * 获取红包信息
     */
    async function checkAvailability () {
      try {
        console.log('checkAvailability', redPackId)

        const result = await checkRedPackAvailability(redPackId)

        console.log('checkAvailability', result)

        redPackInfo.tokenAddress = result.token_address
        redPackInfo.balance = result.balance.toString()
        redPackInfo.total = result.total.toString()
        redPackInfo.claimed = result.claimed.toString()
        redPackInfo.expired = result.expired
        redPackInfo.claimedAmount = result.claimed_amount.toString()
      } catch (error) {
        console.log('checkAvailability', error)
      }
    }

    /**
     * 获取红包简短详情
     */
    // async function getEnvelopeShort () {
    //   const data = await Http.get<{
    //     amount: string;
    //     chainId: string;
    //     decimal: number;
    //     denom: string;
    //     envelopeId: string;
    //     expiredDate: number;
    //     message: string;
    //     sendDate: number;
    //     sender: string;
    //     title: string;
    //   }>({
    //     url: '/redenvelope/v1/envelope/short',
    //     params: {
    //       chainId: query.chainIdInit,
    //       envelopeId: redPackId
    //     }
    //   })

    //   redPackBasicInfo.sender = data.sender
    //   redPackBasicInfo.denom = data.denom
    //   redPackBasicInfo.title = data.title
    //   redPackBasicInfo.chainId = data.chainId
    // }

    /**
     * 生成RSV
     */
    async function generateRSV (captcha: string) {
      const response = await Http.get<{
        r: string;
        s: string;
        v: string;
        address: string;
        envelopeId: string;
      }>({
        url: '/redenvelope/v1/signature',
        params: {
          chainId: query.chainIdInit,
          envelopeId: query.redPackId,
          address: address.value.show,
          captcha,
          nonce: query.nonce
        }
      })

      return response
    }

    async function txData () {
      // 人机验证
      const captcha = await recaptcha.execute('submit')

      // 获取RSV
      const rsv = await generateRSV(captcha)

      const params = [
        query.redPackId,
        rsv.v,
        rsv.r,
        rsv.s
      ] as Parameters<HappyRedPacket['claim']>

      return redPackContract.value.encode('claim', params)
    }

    async function sendTx (txParams: providers.TransactionRequest) {
      if (wallet.value) {
        try {
          const { gasPrice, gasLimit } = await wallet.value.gasFee(txParams)

          const tx = await wallet.value.signer.sendTransaction({
            ...txParams,
            gasPrice,
            gasLimit
          })

          loading.value = true

          const txResult = await wallet.value.provider.waitForTransaction(tx.hash)

          if (txResult.status === 1) {
            routeViewRecord()
          }
        } catch (err) {
          console.log('createRedPackHandler', err)

          loading.value = false

          throw err
        }
      }
    }

    /**
     * 打开红包处理
     */
    async function openHandler () {
      openLoading.value = true

      try {
        // 打开红包前，调合约查看红包状态
        const redpackResult = await checkRedPackAvailability(redPackId)

        // 红包是否处于不可用状态
        const redPackUnAvailable =
            checkRedPackFinished(
              redpackResult.claimed.toString(),
              redpackResult.total.toString()
            ) || redPackInfo.expired

        if (redPackUnAvailable) {
          // 直接跳转红包详情
          return routeViewRecord()
        }

        const data = await txData()

        const txParams: providers.TransactionRequest = {
          to: redPackContract.value.contract.address,
          data
        }

        await sendTx(txParams)
      } catch (err) {
        console.error('open redpack error', err)
      } finally {
        openLoading.value = false
      }
    }

    async function shareHandler () {
      const link = location.href

      window.fxwallet.sendMessage('open_share', link, (err: any, res: any) =>
        console.log('sendMessage', 'open_share', err, res)
      )
    }

    const openWalletWait = ref(false)

    function routeViewRecord () {
      router.push({
        name: 'ViewRecords',
        query: {
          redPackId,
          skin: query.skin
        }
      })
    }

    provide('redPackBasicInfo', redPackBasicInfo)

    watch(infoReady, async val => {
      if (val) {
        await checkAvailability()

        redPackReady.value = true
      }
    })

    onMounted(async () => {
      if (!isFxWallet) {
        router.push({
          name: 'download',
          query
        })

        return
      }

      if (infoReady.value) {
        await checkAvailability()

        redPackReady.value = true
      }
    })

    onUnmounted(() => {
      const grecaptchaBadgeDom =
        document.getElementsByClassName('grecaptcha-badge')[0]

      if (grecaptchaBadgeDom) {
        grecaptchaBadgeDom.remove()
      }

      // console.log(grecaptchaBadgeDom)
      // window.grecaptcha.reset()
    })

    return {
      showViewRecords,
      isType,
      chainIdInit,
      isViewRecords,
      redPackInfo,
      redPackBasicInfo,
      isRedPackAailable,
      isRedPackReceive,
      isRedPackFinished,
      isRedPackOwn,
      openHandler,
      loading,
      redPackReady,
      walletReady,
      redPackId,
      address,
      shareHandler,
      openLoading,
      routeViewRecord,
      query,
      openWalletWait,
      recaptchaCode
    }
  }
})
